/******************************************************************************************
 *	Reseller Impersonator Controller
 *******************************************************************************************
 *
 * All License Admin states that require a reseller ID in order to perform an operation pass through this controller
 * which sets the current user's impersonated reseller before it's required.
 */
(function() {
  angular.module('rcControllers.resellerImpersonator', []).controller(
    'ResellerImpersonatorController',
    /* @ngInject */
    function(User, Redirector, BreadcrumbsMenu, impersonatedReseller) {
      if (impersonatedReseller) {
        User.setImpersonatedReseller(impersonatedReseller);

        //Add the reseller name as the first item in the breadcrumbs menu
        BreadcrumbsMenu.setPersistentItems([
          {
            label: User.getResellerName(),
            stateName: 'licenseAdmin.impersonatedReseller.dashboard'
          }
        ]);
      } else {
        //If the impersonated reseller data didn't make it here from the route resolve property,
        //chicken out and redirect to user default route.
        Redirector.go();
      }
    }
  );
})();
